import { NavLink } from 'react-router-dom';

import { styled } from '@mui/material/styles';

export const StyledHelpListItemIconWrapper = styled('li')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  minWidth: 0,
  marginTop: 'auto',
  marginBottom: theme.spacing(3),
}));

export const Bar = styled('nav')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 120,
  height: 'calc(100vh - 56px)', // 56px is the height of the header,
  paddingTop: theme.spacing(4),
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.primary.dark,
  fontFamily: 'Calibre',
}));

export const List = styled('ul')(() => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  maxHeight: 'calc(100vh - 56px)', // 56px is the height of the header
}));

const createLinkStyles = (theme, active) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  gap: theme.spacing(1.5),
  width: '100%',
  padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
  borderRight: active ? `4px solid ${theme.palette.success.main}` : 'none',
  color: theme.palette.primary.dark,
  fontSize: '14px',
  fontWeight: 500,
  textAlign: 'center',
  textDecoration: 'none',

  '& svg': {
    width: '32px',
    height: '32px',
  },

  '&:hover': {
    textDecoration: 'none',
    backgroundColor: theme.palette.action.hover,
  },

  '&:visited': {
    color: `${theme.palette.primary.dark} !important`, // Because in App.css we have a rule for all links with important tag
  },

  '&.active, &.active:visited': {
    padding: `${theme.spacing(2)} ${theme.spacing(0.5)} ${theme.spacing(2)} ${theme.spacing(1)}`,
    borderRight: `4px solid ${theme.palette.success.main}`,
    backgroundColor: theme.palette.primary.dark,
    color: `${theme.palette.success.main} !important`,

    '&:hover': {
      textDecoration: 'none',
      backgroundColor: theme.palette.primary.dark,
    },
  },
});

export const ListItemNavLink = styled(NavLink)(({ theme, active }) =>
  createLinkStyles(theme, active),
);

export const AbsoluteLink = styled('a')(({ theme }) => createLinkStyles(theme, false));
